module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '' && _vm.form.fields.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Név")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.nev),
      expression: "form.hallgato_alapadatok.nev"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "nev"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.nev)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.nev = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Neptun azonosító")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.neptunkod),
      expression: "form.hallgato_alapadatok.neptunkod"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "neptunkod"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.neptunkod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.neptunkod = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Szak")]), _vm._v(" "), _c('p', {
    staticClass: "form-group-info"
  }, [_vm._v("(A szak képesítési követelményeit meghatározó Korm. rendelet szerinti megnevezés).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.szak),
      expression: "form.hallgato_alapadatok.szak"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "szak"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.szak)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.szak = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Aktív félévek száma")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.aktiv_felevek_szama),
      expression: "form.hallgato_alapadatok.aktiv_felevek_szama"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "aktiv_felevek_szama"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.aktiv_felevek_szama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.aktiv_felevek_szama = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Születési hely, idő")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.szulhelyido),
      expression: "form.hallgato_alapadatok.szulhelyido"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "szulhelyido"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.szulhelyido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.szulhelyido = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Kar")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.kar),
      expression: "form.hallgato_alapadatok.kar"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "kar"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.kar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.kar = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Képzés szintje")]), _vm._v(" "), _c('p', {
    staticClass: "form-group-info"
  }, [_vm._v(" ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.kepzes_szint),
      expression: "form.hallgato_alapadatok.kepzes_szint"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "kepzes_szint"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.kepzes_szint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.kepzes_szint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Megszerzett kreditpontok száma")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.kreditek_szama),
      expression: "form.hallgato_alapadatok.kreditek_szama"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "kar"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.kreditek_szama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.kreditek_szama = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Tanulmányok\n          "), _c('div', {
    staticClass: "form-block-point"
  }, [_c('span', [_vm._v(_vm._s(_vm.tanulmanyok_pont) + " / " + _vm._s(_vm.tanulmanyok_max_pont))]), _vm._v(" pont\n          ")])]), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "label": "Szakok",
      "id": "szak_id",
      "name": "szak_id",
      "options": _vm.szak_combo_opts
    },
    on: {
      "onChange": function (index) {
        _vm.szakValt(index, true, true);
      }
    },
    model: {
      value: (_vm.szak_combo_index),
      callback: function($$v) {
        _vm.szak_combo_index = $$v
      },
      expression: "szak_combo_index"
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Az előző " + _vm._s(_vm.elozo_tanev) + " tanév átlaga")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("I. félév")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_atlagok.felev1),
      expression: "form.hallgato_atlagok.felev1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "tanulm_ef"
    },
    domProps: {
      "value": (_vm.form.hallgato_atlagok.felev1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_atlagok.felev1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("II. félév")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_atlagok.felev2),
      expression: "form.hallgato_atlagok.felev2"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "tanulm_mf"
    },
    domProps: {
      "value": (_vm.form.hallgato_atlagok.felev2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_atlagok.felev2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Átlag")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_atlagok.atlag),
      expression: "form.hallgato_atlagok.atlag"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "tanulm_atlag"
    },
    domProps: {
      "value": (_vm.form.hallgato_atlagok.atlag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_atlagok.atlag = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', [_vm._v("Nyelvvizsgák")]), _vm._v(" "), _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Kizárólag a Neptun rendszerben a Tanulmányi Ügyintéző által rögzített nyelvvizsgá(k)hoz van lehetőség mellékletként a bizonyítvány másolatának feltöltésére.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "nyelvtudas",
    attrs: {
      "block_once": true,
      "block_point": _vm.sor_pontCalc('nyelvtudas'),
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('nyelvtudas').accepted_files,
      "options": _vm.getFieldByName('nyelvtudas').options,
      "id": _vm.getFieldByName('nyelvtudas').name,
      "label": _vm.getFieldByName('nyelvtudas').label,
      "name": _vm.getFieldByName('nyelvtudas').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'nyelvtudas');
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Szakmai tevékenység\n          "), _c('div', {
    staticClass: "form-block-point"
  }, [_c('span', [_vm._v(_vm._s(_vm.szakmaitevekenyseg_pont) + " / " + _vm._s(_vm.szakmaitevekenyseg_max_pont))]), _vm._v(" pont\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Minden, pályázati útmutatóban megjelölt tevékenységet alátámasztó dokumentum feltöltésével szükséges igazolni.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st1",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "block_point": _vm.sor_pontok.st1,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st1').accepted_files,
      "options": _vm.getFieldByName('st1').options,
      "id": _vm.getFieldByName('st1').name,
      "label": _vm.getFieldByName('st1').label,
      "name": _vm.getFieldByName('st1').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st1');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st2",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "block_point": _vm.sor_pontok.st2,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st2').accepted_files,
      "options": _vm.getFieldByName('st2').options,
      "id": _vm.getFieldByName('st2').name,
      "label": _vm.getFieldByName('st2').label,
      "name": _vm.getFieldByName('st2').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st2');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st3",
    attrs: {
      "block_point": _vm.sor_pontok.st3,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st3').accepted_files,
      "options": _vm.getFieldByName('st3').options,
      "id": _vm.getFieldByName('st3').name,
      "label": _vm.getFieldByName('st3').label,
      "name": _vm.getFieldByName('st3').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st3');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st4",
    attrs: {
      "block_point": _vm.sor_pontok.st4,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st4').accepted_files,
      "options": _vm.getFieldByName('st4').options,
      "id": _vm.getFieldByName('st4').name,
      "label": _vm.getFieldByName('st4').label,
      "name": _vm.getFieldByName('st4').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st4');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st5",
    attrs: {
      "block_point": _vm.sor_pontok.st5,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st5').accepted_files,
      "options": _vm.getFieldByName('st5').options,
      "id": _vm.getFieldByName('st5').name,
      "label": _vm.getFieldByName('st5').label,
      "name": _vm.getFieldByName('st5').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st5');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st6",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "block_point": _vm.sor_pontok.st6,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st6').accepted_files,
      "options": _vm.getFieldByName('st6').options,
      "id": _vm.getFieldByName('st6').name,
      "label": _vm.getFieldByName('st6').label,
      "name": _vm.getFieldByName('st6').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st6');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st7",
    attrs: {
      "block_point": _vm.sor_pontok.st7,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st7').accepted_files,
      "options": _vm.getFieldByName('st7').options,
      "id": _vm.getFieldByName('st7').name,
      "label": _vm.getFieldByName('st7').label,
      "name": _vm.getFieldByName('st7').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st7');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "st8",
    attrs: {
      "block_point": _vm.sor_pontok.st8,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('st8').accepted_files,
      "options": _vm.getFieldByName('st8').options,
      "id": _vm.getFieldByName('st8').name,
      "label": _vm.getFieldByName('st8').label,
      "name": _vm.getFieldByName('st8').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'st8');
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Közéleti, sport és egyéb tevékenység\n          "), _c('div', {
    staticClass: "form-block-point"
  }, [_c('span', [_vm._v(_vm._s(_vm.kozelet_sport_pont) + " / " + _vm._s(_vm.kozelet_sport_max_pont))]), _vm._v(" pont\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Minden, pályázati útmutatóban megjelölt tevékenységet alátámasztó dokumentum feltöltésével szükséges igazolni.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks1",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "block_point": _vm.sor_pontok.ks1,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks1').accepted_files,
      "options": _vm.getFieldByName('ks1').options,
      "id": _vm.getFieldByName('ks1').name,
      "label": _vm.getFieldByName('ks1').label,
      "name": _vm.getFieldByName('ks1').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks1');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks2",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "block_point": _vm.sor_pontok.ks2,
      "hide_all_options": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks2').accepted_files,
      "options": _vm.getFieldByName('ks2').options,
      "id": _vm.getFieldByName('ks2').name,
      "label": _vm.getFieldByName('ks2').label,
      "name": _vm.getFieldByName('ks2').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks2');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks3",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "block_point": _vm.sor_pontok.ks3,
      "hide_all_options": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks3').accepted_files,
      "options": _vm.getFieldByName('ks3').options,
      "id": _vm.getFieldByName('ks3').name,
      "label": _vm.getFieldByName('ks3').label,
      "name": _vm.getFieldByName('ks3').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks3');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks4",
    attrs: {
      "autoFill": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "block_point": _vm.sor_pontok.ks4,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks4').accepted_files,
      "options": _vm.getFieldByName('ks4').options,
      "id": _vm.getFieldByName('ks4').name,
      "label": _vm.getFieldByName('ks4').label,
      "name": _vm.getFieldByName('ks4').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks4');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks5",
    attrs: {
      "block_point": _vm.sor_pontok.ks5,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks5').accepted_files,
      "options": _vm.getFieldByName('ks5').options,
      "id": _vm.getFieldByName('ks5').name,
      "label": _vm.getFieldByName('ks5').label,
      "name": _vm.getFieldByName('ks5').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks5');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks6",
    attrs: {
      "block_point": _vm.sor_pontok.ks6,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks6').accepted_files,
      "options": _vm.getFieldByName('ks6').options,
      "id": _vm.getFieldByName('ks6').name,
      "label": _vm.getFieldByName('ks6').label,
      "name": _vm.getFieldByName('ks6').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks6');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    ref: "ks7",
    attrs: {
      "block_point": _vm.sor_pontok.ks7,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('ks7').accepted_files,
      "options": _vm.getFieldByName('ks7').options,
      "id": _vm.getFieldByName('ks7').name,
      "label": _vm.getFieldByName('ks7').label,
      "name": _vm.getFieldByName('ks7').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'ks7');
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")]), _vm._v(" "), _c('div', {
    staticClass: "form-total-point"
  }, [_c('span', [_vm._v(_vm._s(_vm.ossz_pont) + " / " + _vm._s(_vm.ossz_max_pont))]), _vm._v(" pont\n          ")])])])])]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }), _vm._v(" "), (_vm.remedy) ? _c('div', [_c('div', {
    staticClass: "info-box warning",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n            Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:void(0)",
      "title": ""
    },
    on: {
      "click": function($event) {
        _vm.remedy_popup = true;
      }
    }
  }, [_vm._v("Fellebezés")])]) : _vm._e(), _vm._v(" "), (_vm.remedy_user != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_user.name))]), _vm._v(" (" + _vm._s(_vm.remedy_user.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_user.msg))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.remedy_admin != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés válasz")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_admin.name))]), _vm._v(" (" + _vm._s(_vm.remedy_admin.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_admin.msg))
    }
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.remedy && _vm.$route.query.id != undefined && _vm.remedy_popup) ? _c('Fellebezes', {
    attrs: {
      "form_id": _vm.$route.query.id
    },
    on: {
      "close": function (final) {
        _vm.remedy_popup = false;
        if (final) { _vm.remedy = false; }
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/nemzeti_felsooktatasi_osztondij_2025_palyazati_felhivas.pdf",
      "title": "Pályázati felhívás letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázati felhívás")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/nemzeti_felsooktatasi_osztondij_2025_palyazati_utmutato.pdf",
      "title": "Pályázati útmutató letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázati útmutató")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/nemzeti_felsooktatasi_osztondij_2025_osztondijindexek.pdf",
      "title": "Ösztöndíjindex tájékoztató letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Ösztöndíjindex tájékoztató")]), _vm._v(" letöltés\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n          Alapadatok\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc6509b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/nemzeti_felsooktatasi_osztondij.vue
// module id = 390
// module chunks = 0